<template>
  <div class="employee-ip">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Review nhân viên" :filters="filters" :getData="getData" :getDetail="getDetail" :headers="mainHeaders" 
    :detailWidth="1000" :cellSlots="cellSlots" tableKey="keyEmployeeCode">
      <template #viewSection="{ item, selected }" >
        <!-- <detail :item="item" :selected="selected"></detail> -->
      </template>
      
      <template #action1>
        <assign-ip></assign-ip>
      </template>
      
      <template #departmentIpAddressQueries="{cell}">
      <v-chip v-for="(item,key) in cell.departmentIpAddressQueries" :key="key" small label class="mx-2 my-1" :color="item.departmentName == 'Văn phòng 359' ? 'red lighten-4' : 'green lighten-4'"
       v-show="item.ipAddress">
        ({{ key+1 }})<b class="mr-2">{{ item.departmentName }}:</b> {{ item.ipAddress }}
      </v-chip>
        <!-- {{cell.departmentIpAddressQueries}} -->
      </template>
    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { get, getDetailByEmployee, setFinal, getFinal, removeFinal, getFinalSession, getReady, setReady, initReady, generateReview, changeConfirmedBy, changeApprovedBy } from './api'
import { main, finalHeaders, readyHeaders } from './header'
import AssignIp from './AssignIp.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import moment from 'moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "EmployeeIp",
  components: {
    IndexView,
    AssignIp,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'employeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'employeeName', label:'Tên NS', type: 'text', value: '' },
        {name: 'type', label:'Phân loại', type: 'select', value: '',
        selectItems: [
          {text: 'AM', value: 'AM' },
          {text: 'RM', value: 'RM' }, 
          {text: 'SO', value: 'SO' }, 
          {text: 'Standard', value: 'STANDARD' },
          {text: 'Exception', value: 'EXCEPTION' },
        ] },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['departmentIpAddressQueries'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      finalHeaders : finalHeaders,
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    }
  },
  methods: {
    getData: get,
    getDetail: getDetailByEmployee,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {
    // this.getFinal().then(d => {
    // });
    // this.getEmployee();
    this.getFinalSession(2025)
  }
}
</script>